import { ListAction, ListBranch, ListBranchItem } from '../types-store';
import { mapCheckedValues } from './map-checked-values';

export const applySelection = (
  listBranch: ListBranch[],
  listActions: ListAction[],
  initialValueSelected: (item: ListBranchItem) => boolean,
  applySelectedValue: (item: ListBranchItem, selected: boolean) => ListBranchItem
): ListBranch[] => {

  const selectedValues = mapCheckedValues(listBranch, listActions, initialValueSelected);

  return listBranch
    .map(branch => ({
      ...branch,
      items: branch.items.map(item => applySelectedValue(item, selectedValues[item.id]))
    }));
};
